import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga';
import CustomModal from '../components/CustomModal';

const Unity = (): JSX.Element => {
  // eslint-disable-next-line global-require
  const { detect } = require('detect-browser');
  const browser = detect();
  const [modalStatus, displayModal] = useState(false);

  useEffect(() => {
    const buildUrl = 'Build';
    const loaderUrl = `${buildUrl}/LocalServer.loader.js`;

    const config = {
      dataUrl: `${buildUrl}/LocalServer.data`,
      frameworkUrl: `${buildUrl}/LocalServer.framework.js`,
      codeUrl: `${buildUrl}/LocalServer.wasm`,
      streamingAssetsUrl: 'StreamingAssets',
      companyName: 'SpacesInteractive',
      productName: 'WEHI',
      productVersion: '0.1',
    };

    const container = document.getElementById('unity-container');
    const canvas = document.getElementById('unity-canvas');
    const loadingBar = document.getElementById('unity-loading-bar');
    const progressBarFull = document.getElementById('unity-progress-bar-full');

    function isCanvas(obj: HTMLCanvasElement | HTMLElement): obj is HTMLCanvasElement {
      return obj.tagName === 'CANVAS';
    }

    // calculating ratio dynamically.
    if (canvas) {
      if (isCanvas(canvas)) {
        canvas.width = canvas.clientWidth * window.devicePixelRatio;
        canvas.height = canvas.clientHeight * window.devicePixelRatio;
        if (canvas && canvas.style && canvas.style.width) {
          canvas.style.width = (canvas.clientWidth * window.devicePixelRatio).toString();
        }
        if (canvas && canvas.style && canvas.style.height) {
          canvas.style.height = (canvas.clientHeight * window.devicePixelRatio).toString();
        }
      }
    }

    if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
      if (container) container.className = 'unity-mobile';
    } else {
      if (canvas && canvas.style && canvas.style.width) canvas.style.width = '100%';
      if (canvas && canvas.style && canvas.style.height) canvas.style.height = '100%';
    }

    if (loadingBar) loadingBar.style.display = 'block';

    const script = document.createElement('script');
    script.src = loaderUrl;

    script.onload = () => {
      createUnityInstance(canvas, config, (data: number) => {
        if (progressBarFull) progressBarFull.style.width = `${100 * data}%`;
      }).then((unityInstance) => {
        if (loadingBar) loadingBar.style.display = 'none';

        // class to fix the height within the experience
        if (canvas) canvas.classList.add('mobile-fix');
      }).catch((message) => {
        // console.log({message})
      });
    };
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);
  }, []);

  useEffect(() => {
    // handle the case where we don't detect the browser
    if (browser) {
      // console.log("browser.name ", browser.name)
      if (browser.name === 'firefox' && !modalStatus) {
        displayModal(true);
      }
    }
  }, []);

  return (
    <div className="unity">
      <div id="unity-container" className="unity-desktop">
        <canvas id="unity-canvas" />
        <div id="unity-loading-bar">
          <div id="unity-logo" />
          <div id="unity-progress-bar-empty">
            <div id="unity-progress-bar-full" />
          </div>
          <div className="message">
            <p>
              We hope you enjoy Art of Science.
            </p>
            <br />
            <p>
              When you enter the exhibition,
              Vivaldi`s <em>Four Seasons </em>
              by the Melbourne Symphony Orchestra will play automatically.
            </p>
            <p>You may need to adjust your volume.
              There is also a mute button located at the top
              right-hand side of the exhibition screen.
            </p>
            <br />
            <p>
              Clicking on artworks will tell you about them and
              allow you to vote for your favourite image.
            </p>
          </div>
        </div>
      </div>
      {
        modalStatus &&
        <CustomModal
          title=""
          modalStatus={modalStatus}
          handleClose={() => displayModal(false)}
        >
          <h1>WEHI - ART OF SCIENCE ONLINE EXHIBITION</h1>
          <p>We noticed you are using Mozilla Firefox.
            We recommend using Google Chrome for the best user experience.
          </p>
          {/* <p>1. Click on ‘Firefox’ on the menu of the browser</p> */}
          {/* <p>2. Click on ‘Preferences’</p> */}
          {/* <p>3. Scroll to ‘Performance’</p> */}
          {/* <p>4. Unselect ‘Use recommended performance settings’</p> */}
          {/* <p>5. Unselect ‘Use hardware acceleration when available’</p> */}
          {/* <p>Exit preferences, reload the page and enjoy the experience</p> */}
        </CustomModal>
      }
    </div>
  );
};

export default Unity;
